

export const JOIN_EVENTS = ["Google Hangouts/Meet", "Google Meet interview", "Microsoft Teams interview", "Microsoft Teams", "Microsoft Teams Interview", "Google Meet Interview"];